type EventWithCreationDates<TFirebaseCreateAt, TCreatedAt> = Readonly<{
  firebaseCreateAt?: TFirebaseCreateAt | null;
  createdAt?: TCreatedAt | null;
}>;

/**
 * When was this event created? Only the Firebase importer sets `firebaseCreateAt`, so a Firebase-free
 * event's creation is its row's `createdAt`; an imported event's `createdAt` is the import, not the event.
 */
export function getEventCreationDate<TFirebaseCreateAt, TCreatedAt>(
  event: EventWithCreationDates<TFirebaseCreateAt, TCreatedAt> | null | undefined,
): TFirebaseCreateAt | TCreatedAt | undefined {
  return event?.firebaseCreateAt ?? event?.createdAt ?? undefined;
}
